module.exports = __webpack_public_path__ + "static/media/trainVideo3.1eae3331.mp4";